// FETCH ALL PARTY DETAILS
export const FETCH_PARTY_DETAILS_REQUEST = 'FETCH_PARTY_DETAILS_REQUEST';
export const FETCH_PARTY_DETAILS_SUCCESS = 'FETCH_PARTY_DETAILS_SUCCESS';
export const FETCH_PARTY_DETAILS_FAILURE = 'FETCH_PARTY_DETAILS_FAILURE';

// FETCH ALL PARTY DETAILS
export const FETCH_PARTY_DETAILS_WITHOUT_ID_REQUEST = 'FETCH_PARTY_DETAILS_WITHOUT_ID_REQUEST';
export const FETCH_PARTY_DETAILS_WITHOUT_ID_SUCCESS = 'FETCH_PARTY_DETAILS_WITHOUT_ID_SUCCESS';
export const FETCH_PARTY_DETAILS_WITHOUT_ID_FAILURE = 'FETCH_PARTY_DETAILS_WITHOUT_ID_FAILURE';

export const FETCH_PARTY_DETAILS_PAN_FILE_REQUEST = 'FETCH_PARTY_DETAILS_PAN_FILE_REQUEST';
export const FETCH_PARTY_DETAILS_PAN_FILE_SUCCESS = 'FETCH_PARTY_DETAILS_PAN_FILE_SUCCESS';
export const FETCH_PARTY_DETAILS_PAN_FILE_FAILURE = 'FETCH_PARTY_DETAILS_PAN_FILE_FAILURE';

export const FETCH_PARTY_DETAILS_GST_FILE_REQUEST = 'FETCH_PARTY_DETAILS_GST_FILE_REQUEST';
export const FETCH_PARTY_DETAILS_GST_FILE_SUCCESS = 'FETCH_PARTY_DETAILS_GST_FILE_SUCCESS';
export const FETCH_PARTY_DETAILS_GST_FILE_FAILURE = 'FETCH_PARTY_DETAILS_GST_FILE_FAILURE';

// CREATE PARTY DETAILS
export const CREATE_PARTY_DETAILS_REQUEST = 'CREATE_PARTY_DETAILS_REQUEST';
export const CREATE_PARTY_DETAILS_SUCCESS = 'CREATE_PARTY_DETAILS_SUCCESS';
export const CREATE_PARTY_DETAILS_FAILURE = 'CREATE_PARTY_DETAILS_FAILURE';

// UPDATE PARTY DETAILS
export const UPDATE_PARTY_DETAILS_REQUEST = 'UPDATE_PARTY_DETAILS_REQUEST';
export const UPDATE_PARTY_DETAILS_SUCCESS = 'UPDATE_PARTY_DETAILS_SUCCESS';
export const UPDATE_PARTY_DETAILS_FAILURE = 'UPDATE_PARTY_DETAILS_FAILURE';

// FETCH SINGLE STATE OF PARTY DETAILS
export const FETCH_SINGLE_PARTY_DETAILS_REQUEST = 'FETCH_SINGLE_PARTY_DETAILS_REQUEST';
export const FETCH_SINGLE_PARTY_DETAILS_SUCCESS = 'FETCH_SINGLE_PARTY_DETAILS_SUCCESS';
export const FETCH_SINGLE_PARTY_DETAILS_FAILURE = 'FETCH_SINGLE_PARTY_DETAILS_FAILURE';

// DELETE PARTY DETAILS
export const DELETE_PARTY_DETAILS_REQUEST = 'DELETE_PARTY_DETAILS_REQUEST';
export const DELETE_PARTY_DETAILS_SUCCESS = 'DELETE_PARTY_DETAILS_SUCCESS';
export const DELETE_PARTY_DETAILS_FAILURE = 'DELETE_PARTY_DETAILS_FAILURE';

export const RESET_PARTY_DETAILS_INFO = 'RESET_PARTY_DETAILS_INFO';
export const RESET_PARTY_DETAILS = 'RESET_PARTY_DETAILS';

export const CREATE_PARTY_DETAILS_FORM = 'CREATE_PARTY_DETAILS_FORM';

export const UPDATE_PARTY_DETAILS_FORM = 'UPDATE_PARTY_DETAILS_FORM';

export const SET_PAN_FILE_NAME_PARTY_DETAILS = 'SET_PAN_FILE_NAME_DETAILS';

export const SET_GST_FILE_NAME_PARTY_DETAILS = 'SET_GST_FILE_NAME_DETAILS';
